import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Switch, Select, message } from 'antd';
import { companyTaxService } from '../../../../services/api';

const { Option } = Select;

const TaxTemplateModal = ({
  visible,
  onCancel,
  onOk,
  loading,
  companyId,
  initialValues
}) => {
  const [form] = Form.useForm();
  const [taxes, setTaxes] = useState([]);
  const [fetchingTaxes, setFetchingTaxes] = useState(false);

  useEffect(() => {
    if (visible && companyId) {
      fetchTaxes();
    }
    if (visible && initialValues) {
        const taxIds = initialValues.details ? initialValues.details.map(d => d.company_tax_id) : [];
      form.setFieldsValue({
        ...initialValues,
        tax_ids: taxIds
      });
    } else {
      form.resetFields();
    }
  }, [visible, initialValues, companyId]);

  const fetchTaxes = async () => {
    try {
      setFetchingTaxes(true);
      const response = await companyTaxService.getTaxes(companyId);
      setTaxes(response.data.taxes || []);
    } catch (error) {
      console.error('Error fetching taxes:', error);
      message.error('Error al cargar impuestos');
    } finally {
      setFetchingTaxes(false);
    }
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onOk(values);
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  return (
    <Modal
      title={initialValues ? 'Editar Template' : 'Nuevo Template'}
      open={visible}
      onOk={handleSubmit}
      onCancel={onCancel}
      confirmLoading={loading}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          is_default: false
        }}
      >
        <Form.Item
          name="name"
          label="Nombre del Template"
          rules={[{ required: true, message: 'Por favor ingrese el nombre' }]}
        >
          <Input placeholder="Ej: RESICO Persona Física" />
        </Form.Item>

        <Form.Item
          name="description"
          label="Descripción"
        >
          <Input.TextArea rows={2} placeholder="Descripción opcional" />
        </Form.Item>

        <Form.Item
          name="tax_ids"
          label="Impuestos"
          rules={[{ required: true, message: 'Seleccione al menos un impuesto' }]}
        >
          <Select
            mode="multiple"
            placeholder="Seleccione los impuestos"
            loading={fetchingTaxes}
            optionFilterProp="children"
          >
            {taxes.map(tax => (
              <Option key={tax.id} value={tax.id}>
                {tax.tax_name} ({tax.tax_code} - {(parseFloat(tax.tasa_o_cuota) * 100).toFixed(2)}%){!tax.is_active && ' (Inactivo)'}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="is_default"
          valuePropName="checked"
          label="Template por defecto"
        >
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TaxTemplateModal;
